import React from "react";
import {
  StyledUl,
  StyledLi,
  GrayText,
  Title,
  BlueLink,
  Card,
  Blockquote,
  SpaceY,
  Ol,
  BgGraySm,
  FontBold,
  BorderT,
  Pl20,
  Pl4P,
} from "./styled-help-components";

export const HELP_CONTENT = {
  sales: {
    title: "실시간 매출",
    sections: [
      {
        subtitle: "실시간 매출이란?",
        content: (
          <>
            <p>
              바디코디 CRM에 기록된 판매 내역을 바탕으로 “오늘, 이번 주, 이번
              달” 매출을 보여주는 지표입니다. 매출은 아래와 같이 계산됩니다.
            </p>
            <StyledUl>
              <StyledLi>
                매출금액 = 결제금액 + 미수금
                <GrayText>(=상품의 정가 - 포인트 할인 - 금액 할인)</GrayText>
              </StyledLi>
            </StyledUl>
            <p>
              총매출 아래에는 이용권 분류별 매출이 동일한 방식으로 표시됩니다.
              단, 패키지 상품은 최초 등록 시 설정한 내부 상품 가격을 기준으로
              매출이 나뉩니다.
              <br />
              <GrayText>
                (ex. 헬스(회원권)+개인락커(옵션) 6개월 패키지를 헬스(회원권)
                30만원, 락커(옵션) 6만원으로 설정해 판매했다면 회원권 매출
                30만원, 옵션 매출 6만원으로 집계됩니다.)
              </GrayText>
            </p>
          </>
        ),
      },
      {
        subtitle: "정확한 매출 관리를 위한 안내",
        content: (
          <>
            <p>
              바디코디와 연동되지 않은 결제기기를 사용하면, CRM에 수기 입력한
              정보를 바탕으로 매출이 계산되므로 실제와 차이가 날 수 있습니다.
              관리자의 실수나 어뷰징을 막고 매출을 정확하게 추적하려면 '바디코디
              연동 카드 단말기' 또는 '회원 앱 결제(비페이)' 사용을 권장합니다.
            </p>
            <BlueLink
              onClick={() => {
                //@ts-expect-error:__
                if (window.ReactNativeWebView) {
                  const data = JSON.stringify({
                    type: "openExternalLink",
                    link: "https://pf.kakao.com/_WaLZC/chat",
                  });
                  //@ts-expect-error:__
                  window.ReactNativeWebView.postMessage(data);
                } else {
                  window.location.href = "https://pf.kakao.com/_WaLZC/chat";
                }
              }}
            >
              [바디코디 전용 결제기 도입 문의 (카카오톡 상담)]
            </BlueLink>
            <Title style={{ fontSize: 16 }}>기간별 매출 안내</Title>
            <StyledUl>
              <StyledLi>
                <FontBold>이번 주 매출:</FontBold> 이번 주 월요일부터 현재까지의
                누적 매출
              </StyledLi>
              <StyledLi>
                <FontBold>이번 달 매출:</FontBold> 이번 달 1일부터 현재까지의
                누적 매출
              </StyledLi>
              <StyledLi>
                <FontBold>전주/전달 대비 증감률:</FontBold> 지난주/지난달의 같은
                기간까지의 매출과 비교한 값
                <br />
                <GrayText>
                  (예: 현재가 수요일이라면, 이번 주 월~수요일 매출을 지난주
                  월~수요일 매출과 비교)
                </GrayText>
              </StyledLi>
            </StyledUl>
          </>
        ),
      },
    ],
  },
  activeMembers: {
    title: "실시간 유효회원",
    sections: [
      {
        subtitle: "실시간 유효회원이란?",
        content: (
          <p>
            현재 유효한 이용권(회원권)을 한 개 이상 보유한 회원을 의미하며,
            CRM에 등록된 정보를 기준으로 집계됩니다. 단, 이용권을 구매한 적이
            없거나 보유한 모든 이용권이 만료(기간 만료, 횟수 소진 등)되었거나
            이용 예정인 이용권만 있는 경우는 유효회원에 포함되지 않습니다.
          </p>
        ),
      },
      {
        subtitle: "분류별 유효회원 안내",
        content: (
          <StyledUl style={{ paddingTop: 0 }}>
            <StyledLi>
              <FontBold>분류별 유효회원 수:</FontBold> 해당 분류의 유효한
              이용권을 한 개 이상 보유한 회원의 수
            </StyledLi>
            <StyledLi>
              <FontBold>분류별 비율(%):</FontBold> 전체 유효회원 중, 해당 분류의
              유효회원이 차지하는 비중
              <br />
              <GrayText>
                (예: 전체 유효회원이 100명이고, 이 중 개인레슨 이용권을 보유한
                회원이 20명이라면 개인레슨 유효회원 비율은 20%로 표시됩니다.)
              </GrayText>
            </StyledLi>
          </StyledUl>
        ),
      },
    ],
  },
  monthlySales: {
    title: "총 매출",
    sections: [
      {
        subtitle: "월 총 매출이란 무엇인가요?",
        content: (
          <>
            <p style={{ marginBottom: "0.5rem" }}>
              '월 총 매출'은 해당 월에 발생한 모든 판매 건의 합계 금액을
              의미합니다.
            </p>
            <Card style={{ paddingTop: 0, paddingBottom: 0 }}>
              <StyledUl>
                <StyledLi>
                  <FontBold>산출 공식:</FontBold> 해당 월의 모든 판매 건의
                  [결제금액+미수금]의 합계
                </StyledLi>
                <StyledLi>
                  할인금액을 제외한 실제 결제할 금액이며, 결제가 완료되지 않은
                  미수금도 해당 월의 매출로 포함하여 집계합니다.
                </StyledLi>
              </StyledUl>
            </Card>
          </>
        ),
      },
      {
        subtitle: "데이터는 언제 반영되나요?",
        content: (
          <StyledUl style={{ paddingTop: 0, paddingBottom: 0 }}>
            <StyledLi>
              <FontBold>현재 진행 중인 월</FontBold>
              <Pl20>
                모든 변경사항이 <FontBold>실시간</FontBold>으로 반영됩니다. 신규
                판매, 결제금액 수정, 결합, 업그레이드, 교체, 환불 등 모든 내역이
                즉시 '월 총 매출'에 업데이트됩니다.
              </Pl20>
            </StyledLi>
            <StyledLi>
              <FontBold>지난 월(과거 월)</FontBold>
              <Pl20>
                해당 월의 마지막 날을 기준으로 매출이 ‘확정(마감)’됩니다. 월
                매출이 마감된 이후에는 과거 날짜로 판매 건을 수정하거나
                추가하더라도, 마감된 '월 총 매출' 금액은 더 이상 변경되지
                않습니다. 이는 월별 성과를 일관된 기준으로 관리하기 위함입니다.
              </Pl20>
            </StyledLi>
          </StyledUl>
        ),
      },
      {
        subtitle: "왜 다른 메뉴의 매출 데이터와 차이가 있나요?",
        content: (
          <SpaceY>
            <p>
              위와 같은 '월말 마감' 정책으로 인해, 본 화면의{" "}
              <FontBold>과거 월 총 매출</FontBold>은<br />
              <FontBold>회계관리 메뉴-매출조회</FontBold>에서 보는 실시간
              데이터와 다를 수 있습니다.
            </p>
            <StyledUl style={{ paddingTop: 0, paddingBottom: 0 }}>
              <StyledLi>
                <FontBold>경영대시보드(월 매출 분석):</FontBold> 월말 기준으로
                '확정된 실적'을 보여줍니다.
              </StyledLi>
              <StyledLi>
                <FontBold>매출조회 메뉴:</FontBold> 월말 마감 이후의 수정
                내역까지 모두 반영된 '최신 실시간 현황'을 보여줍니다.
              </StyledLi>
            </StyledUl>
            <p>
              이는 부정확한 데이터가 아니라, 데이터를 바라보는 기준의
              차이입니다. 저희는 월별 실적을 명확하게 비교 분석할 수 있도록
              확정된 기준을 제공하고 있습니다.
            </p>
            <Card>
              <FontBold>[향후 업데이트 예정]</FontBold> 월말 마감 매출과 실시간
              매출 간의 차이가 발생했을 때, 그 상세 변경 이력을 쉽게 확인하고
              비교할 수 있는 기능을 추가하여 더욱 정교한 매출 관리를 지원할
              예정입니다.
            </Card>
          </SpaceY>
        ),
      },
    ],
  },
  averageSales: {
    title: "평균 판매가격",
    sections: [
      {
        subtitle: "평균 판매가격",
        content: (
          <p>
            해당 월의 모든 판매내역을 기준으로 회원 1인당 평균 판매가를
            의미합니다.
          </p>
        ),
      },
      {
        subtitle: "월 평균 판매 가격",
        content: (
          <StyledUl style={{ paddingTop: 0, paddingBottom: 0 }}>
            <StyledLi>
              <FontBold>계산 공식</FontBold>
              <Pl4P>
                해당 월의 모든 판매내역의 총 판매가 / 해당 월의 판매 회원
                수(중복 제외)
              </Pl4P>
            </StyledLi>
            <StyledLi>
              <FontBold>핵심 기준</FontBold>
              <Pl4P>
                한 회원에게 월 내에 여러 번 판매하더라도 '1명'으로 집계합니다.
              </Pl4P>
            </StyledLi>
            <BgGraySm>
              <FontBold>예시:</FontBold> A회원에게 한 달 동안 10만 원, 20만
              원어치를 판매했다면, 판매 회원 수는 '1명', 판매가는 합산된 '30만
              원'으로 계산에 반영됩니다.
            </BgGraySm>
          </StyledUl>
        ),
      },
      {
        subtitle: "그래프의 '일별' 평균 판매 가격",
        content: (
          <StyledUl style={{ paddingTop: 0, paddingBottom: 0 }}>
            <StyledLi>
              그래프의 각 점은 <FontBold>하루를 기준</FontBold>으로 계산된
              값입니다.
            </StyledLi>
            <StyledLi>
              <FontBold>계산 공식</FontBold>
              <Card style={{ marginTop: 4 }}>
                해당 일의 총 판매가 / 해당 일의 판매 회원 수(중복 제외)
              </Card>
            </StyledLi>
          </StyledUl>
        ),
      },
    ],
  },
  periodUnitPrice: {
    title: "기간제 객단가",
    sections: [
      {
        subtitle: "기간제 객단가 (30일 환산 평균 판매가)",
        content: (
          <p>
            ‘기간제 객단가’는 판매하신 다양한 기간의 이용권(예: 3개월, 6개월,
            1년)을 '30일(약 1개월)' 기준으로 환산했을 때의 평균 판매 가격입니다.
            즉, 우리 센터가 판매하는 이용권의 '1개월당 평균 가치'가 얼마인지를
            일관된 기준으로 추적하는 핵심 지표입니다.
          </p>
        ),
      },
      {
        subtitle: "어떻게 계산하나요? (계산 방법)",
        content: (
          <SpaceY>
            <p>
              해당 월에 판매된 모든 기간제 이용권에 대해 각각 '30일 평균
              판매가'를 구한 뒤, 이들의 평균을 계산합니다.
            </p>
            <Card>
              <p>
                <FontBold>계산 공식:</FontBold> 해당 월의 전체 판매내역을
                대상으로 각 판매 건의 판매가/이용권 기간(총 일수)*30의 평균 값
              </p>
              <div style={{ marginTop: 4 }}>
                <FontBold>쉽게 보는 계산 예시:</FontBold>
                <p>
                  한 달 동안 아래와 같이 2건의 판매가 발생했다고 가정해
                  보겠습니다.
                </p>
                <StyledUl>
                  <StyledLi>
                    <FontBold>판매 A:</FontBold> 6개월(180일) 이용권을
                    360,000원에 판매
                    <br />
                    <GrayText>
                      → A의 30일 평균 판매가: (360,000원 ÷ 180일) × 30일 =
                      60,000원
                    </GrayText>
                  </StyledLi>
                  <StyledLi>
                    <FontBold>판매 B:</FontBold> 12개월(365일) 이용권을
                    600,000원에 판매
                    <br />
                    <GrayText>
                      → B의 30일 평균 판매가: (600,000원 ÷ 365일) × 30일 ≈
                      49,315원
                    </GrayText>
                  </StyledLi>
                </StyledUl>
              </div>
              <BorderT>
                이번 달 '기간제 객단가' = (60,000원 + 49,315원) ÷ 2건 = 54,657원
              </BorderT>
            </Card>
          </SpaceY>
        ),
      },
      {
        subtitle: "이 지표가 왜 중요한가요? (전략적 중요성)",
        content: (
          <SpaceY>
            <Blockquote style={{ marginTop: 0, marginBottom: 0 }}>
              "단기 현금 흐름의 함정을 피하고, 사업의 장기적인 건강 상태를
              진단하기 위함입니다."
            </Blockquote>
            <p>
              1년치 회원권을 팔아 당장 큰 현금이 들어오면 단기적으로는 성공한
              것처럼 보일 수 있습니다. 하지만 이는 회계적으로 '선수금 부채'이며,
              앞으로 1년간 서비스를 제공해야 할 의무가 함께 따라옵니다.
            </p>
            <StyledUl style={{ paddingTop: 0, paddingBottom: 0 }}>
              <StyledLi>
                <FontBold>잘못된 판단:</FontBold> "이번 달에 12개월권(60만 원)
                10건을 팔아 600만 원의 현금이 들어왔다!"
              </StyledLi>
              <StyledLi>
                <FontBold>정확한 진단:</FontBold> "모든 판매를 '월 5만 원'이라는
                동일한 잣대로 보니, 과도한 할인은 없는지, 우리 서비스의 가치가
                제대로 책정되었는지 객관적으로 판단할 수 있다."
              </StyledLi>
            </StyledUl>
            <p>
              이처럼 각기 다른 이용권을 '월평균 단가'라는 하나의 기준으로
              표준화해야만,{" "}
              <FontBold>과도한 할인 경쟁으로 인한 수익성 악화</FontBold>를
              방지하고 비즈니스의 핵심 지표를 일관성 있게 관리할 수 있습니다.
            </p>
          </SpaceY>
        ),
      },
      {
        subtitle: "어떻게 활용할 수 있나요? (데이터 기반 의사결정)",
        content: (
          <SpaceY>
            <p>
              '기간제 객단가'는 단순히 하나의 숫자가 아니라, 사업의 미래를
              예측하고 성장 전략을 수립하는{" "}
              <FontBold>강력한 의사결정 도구</FontBold>입니다. 이 지표는 아래와
              같은 전문적인 비즈니스 분석의 기초가 됩니다.
            </p>
            <StyledUl style={{ paddingTop: 0, paddingBottom: 0 }}>
              <StyledLi>
                <FontBold>
                  월간 반복 매출 (MRR, Monthly Recurring Revenue)
                </FontBold>
                <Pl4P>
                  현금 흐름이 아닌, 이번 달에 실질적으로 발생한 매출이 얼마인지
                  파악합니다.
                </Pl4P>
              </StyledLi>
              <StyledLi>
                <FontBold>
                  회원당 평균 월간 수익 (ARPM, Average Revenue Per Member)
                </FontBold>
                <Pl4P>
                  우리 센터의 회원 한 명이 매달 평균적으로 얼마의 수익을
                  가져다주는지 분석합니다.
                </Pl4P>
              </StyledLi>
              <StyledLi>
                <FontBold>회원 생애 가치 (LTV, Lifetime Value)</FontBold>
                <Pl4P>
                  회원 한 명이 우리와 함께하는 전체 기간 동안 총 얼마의 가치를
                  창출할 것인지 예측합니다.
                </Pl4P>
              </StyledLi>
              <StyledLi>
                <FontBold>고객 획득 비용 (CAC) 회수 기간</FontBold>
                <Pl4P>
                  신규 회원 한 명을 유치하는 데 쓴 광고비 등의 비용을 회수하는
                  데 몇 개월이 걸리는지 계산하여 마케팅 효율을 측정합니다.
                </Pl4P>
              </StyledLi>
            </StyledUl>
            <p>
              이 지표들을 통해 감(感)에 의존하는 운영이 아닌,{" "}
              <FontBold>데이터에 기반한 전문적인 사업 관리</FontBold>가
              가능해집니다.
            </p>
          </SpaceY>
        ),
      },
    ],
  },
  countUnitPrice: {
    title: "횟수제 객단가 (1회당 평균 판매가)",
    sections: [
      {
        subtitle: "이 지표는 무엇인가요? (정의)",
        content: (
          <SpaceY>
            <p>
              ‘횟수제 객단가’는 PT 또는 수업{" "}
              <FontBold>이용권의 '1회'당 평균 판매 가격</FontBold>입니다.
            </p>
            <p>
              10회, 50회 등 각기 다른 구성으로 판매된 이용권들을{" "}
              <FontBold>'수업 1회'라는 동일한 기준</FontBold>
              으로 가치를 환산하여, 우리 센터의 핵심 서비스가 평균적으로 얼마에
              판매되고 있는지 추적하는 지표입니다.
            </p>
          </SpaceY>
        ),
      },
      {
        subtitle: "어떻게 계산하나요? (계산 방법)",
        content: (
          <SpaceY>
            <p>
              해당 월에 판매된 모든 횟수제 이용권의 '1회당 단가'를 구한 뒤,
              이들의 평균을 계산합니다.
            </p>
            <Card>
              <p>
                <FontBold>계산 공식:</FontBold> 각 판매 건의 (판매가 / 총 횟수)
                값을 모두 더한 후, 총판매 건수로 나눈 평균 값
              </p>
              <div>
                <p>
                  <FontBold>쉽게 보는 계산 예시:</FontBold>
                </p>
                <p>
                  한 달 동안 아래와 같이 2건의 개인레슨이 판매되었다고 가정해
                  보겠습니다.
                </p>
                <StyledUl>
                  <StyledLi>
                    <FontBold>판매 A:</FontBold> 10회 개인레슨을 700,000원에
                    판매
                    <br />
                    <GrayText>
                      A의 1회당 단가: 700,000원 / 10회 ={" "}
                      <FontBold>70,000원</FontBold>
                    </GrayText>
                  </StyledLi>
                  <StyledLi>
                    <FontBold>판매 B:</FontBold> 30회 개인레슨을 1,800,000원에
                    판매
                    <br />
                    <GrayText>
                      B의 1회당 단가: 1,800,000원 / 30회 ={" "}
                      <FontBold>60,000원</FontBold>
                    </GrayText>
                  </StyledLi>
                </StyledUl>
              </div>
              <BorderT>
                이번 달 '횟수제 객단가' = (70,000원 + 60,000원) / 2건 = 65,000원
              </BorderT>
            </Card>
          </SpaceY>
        ),
      },
      {
        subtitle: "이 지표가 왜 중요한가요? (핵심 서비스 수익성 관리)",
        content: (
          <SpaceY>
            <Blockquote style={{ marginTop: 0, marginBottom: 0 }}>
              "단기 매출을 위한 과도한 할인을 방지하고, 핵심 서비스의 가치를
              지키기 위함입니다."
            </Blockquote>
            <p>
              다회차 레슨권을 묶어 판매하면 당장의 매출은 커 보이지만, '1회당
              단가'가 얼마인지 보지 않으면 나도 모르는 사이 수익성이 악화될 수
              있습니다. 특히, 수업료 등 향후 지출해야 할 비용을 고려하면, 낮은
              객단가는 장기적으로 사업 안정성을 위협하는 요인이 됩니다.
            </p>
            <p>
              이 지표를 통해 우리는 "우리 센터의 수업 1회는 최소 얼마 이상을
              받아야 한다"는 명확한 기준을 세우고, 할인 정책을 전략적으로 관리할
              수 있습니다.
            </p>
          </SpaceY>
        ),
      },
      {
        subtitle: "어떻게 활용할 수 있나요? (상품·인력·전략 최적화)",
        content: (
          <SpaceY>
            <p>
              '횟수제 객단가'는 단순한 가격 지표를 넘어,{" "}
              <FontBold>상품, 인력, 판매 전략을 최적화</FontBold>하는 데 필요한
              핵심 데이터를 제공합니다.
            </p>
            <StyledUl style={{ paddingTop: 0, paddingBottom: 0 }}>
              <StyledLi>
                <FontBold>인력(코치/강사) 성과 측정</FontBold>
                <Pl4P>
                  강사별로 '횟수제 객단가'를 비교하여, 누가 더 높은 가치로
                  서비스를 판매하는지 객관적으로 측정하고 생산성을 분석할 수
                  있습니다.
                </Pl4P>
              </StyledLi>
              <StyledLi>
                <FontBold>'스위트 스팟(Sweet Spot)' 상품 발굴</FontBold>
                <Pl4P>
                  '1회당 평균 판매가'와 '총판매량' 데이터를 교차 분석하여,
                  고객들이 가장 선호하면서도 우리에게 가장 높은 수익을 안겨주는
                  최적의 상품(Sweet Spot)을 찾아낼 수 있습니다.
                </Pl4P>
              </StyledLi>
              <StyledLi>
                <FontBold>영업 및 마케팅 전략 고도화</FontBold>
                <Pl4P>
                  어떤 상품(예: 10회권, 30회권)의 객단가가 높고 수요가 많은지
                  데이터에 기반하여 파악하고, 해당 상품을 주력으로 홍보하거나
                  프로모션을 설계하는 등 정교한 판매 전략을 수립할 수 있습니다.
                </Pl4P>
              </StyledLi>
            </StyledUl>
          </SpaceY>
        ),
      },
    ],
  },
  totalActiveMembers: {
    title: "총 유효회원수",
    sections: [
      {
        subtitle: "유효 회원수는 무엇인가요? (정의)",
        content: (
          <Card style={{ paddingTop: 0, paddingBottom: 0 }}>
            <StyledUl>
              <StyledLi>
                총 유효회원수는 이용권을 기준으로 기간과 횟수가 남아있는 유효한
                이용권을 1개 이상 보유한 총 회원수를 의미합니다.
              </StyledLi>
              <StyledLi>
                총 유효회원수는 이용권을 기준으로 기간과 횟수가 남아있는 유효한
                이용권을 1개 이상 보유한 총 회원수를 의미합니다. 즉, 해당 월말
                기준으로 이용권이 모두 만료 되었거나 이용 예정인 이용권만 있는
                경우 유효회원수 집계에 포함되지 않습니다.
              </StyledLi>
              <StyledLi>
                월별 총 유효회원수는 해당 월말 기준으로 유효회원 수를
                집계합니다.
              </StyledLi>
            </StyledUl>
          </Card>
        ),
      },
      {
        subtitle: "매월 유효 회원수를 추적하는 것은 왜 중요할까요?",
        content: (
          <SpaceY>
            <p>
              헬스장 경영에서 단순히 월 매출만 보는 것을 넘어, 매월{" "}
              <FontBold>총 유효회원수</FontBold>와
              <FontBold>이용권 종류별 유효회원수</FontBold>를 추적하는 것은,
              비즈니스의 현재 상태를 진단하고 미래 성장을 예측하며, 궁극적으로
              수익성을 극대화하기 위한 가장 근본적인 활동입니다.
            </p>
            <Ol style={{ paddingLeft: 0 }}>
              <StyledLi>
                <FontBold>
                  총 유효회원수: 비즈니스의 거시적 건강 상태를 보여주는 '활력
                  징후'
                </FontBold>
                <Pl4P>
                  매월 총 유효회원수를 추적하는 것은 센터 사업의 가장 기본적인
                  건강 상태와 성장 동력을 파악하는 데 필수적입니다.
                </Pl4P>
                <StyledUl
                  style={{ paddingLeft: 24, paddingTop: 4, paddingBottom: 0 }}
                >
                  <StyledLi>
                    <FontBold>성장과 쇠퇴의 바로미터:</FontBold> 총 유효회원수는
                    우리 센터가 성장하고 있는지, 정체되어 있는지, 혹은 회원이
                    빠져나가고 있는지를 가장 직관적으로 보여주는 지표입니다.
                    전월 대비, 전년 동기 대비 회원 수의 증감은 마케팅 활동의
                    성과나 시장 변화에 대한 즉각적인 피드백을 제공합니다.
                  </StyledLi>
                  <StyledLi>
                    <FontBold>핵심 성장 지표의 기반:</FontBold> 회원 유지율,
                    이탈률, 회원 성장률과 같은 모든 핵심 성과 지표(KPI)는 '총
                    유효회원수'를 기준으로 계산됩니다. 이 기본 데이터가 정확하지
                    않으면 비즈니스의 건전성을 평가하는 다른 모든 지표의
                    신뢰도가 떨어집니다.
                  </StyledLi>
                  <StyledLi>
                    <FontBold>미래 수익 예측의 기초:</FontBold> 총 유효회원수는
                    월간 반복 매출(MRR)과 회원 생애 가치(LTV)를 예측하는 데 가장
                    중요한 변수입니다. 안정적인 회원 기반은 예측 가능한 수익
                    흐름을 의미하며, 이는 장비 투자, 인력 충원 등 미래 계획을
                    세우는 데 필수적인 근거가 됩니다.
                  </StyledLi>
                </StyledUl>
              </StyledLi>
              <StyledLi>
                <FontBold>
                  이용권 종류별 유효회원수: 수익 구조와 운영 효율을 최적화하는
                  '정밀 진단 도구'
                </FontBold>
                <Pl4P>
                  총 유효회원수가 '얼마나 많은가'를 보여준다면, 이용권 종류별
                  회원수는 <FontBold>'누가, 무엇을, 왜'</FontBold> 알려주는 훨씬
                  더 깊은 전략적 통찰을 제공합니다.
                </Pl4P>
                <StyledUl
                  style={{ paddingLeft: 24, paddingTop: 4, paddingBottom: 0 }}
                >
                  <StyledLi>
                    <FontBold>수익성 높은 상품 식별:</FontBold> 모든 멤버십이
                    동일한 수익을 창출하지는 않습니다. '일반 회원권', 'PT
                    회원권', '필라테스 이용권' 등 종류별 회원 수를 추적하면,
                    어떤 상품이 가장 인기가 많고 비즈니스 수익에 크게 기여하는지
                    파악할 수 있습니다. 예를 들어, PT 회원 수가 꾸준히
                    증가한다면 PT 프로그램을 강화하고 관련 마케팅을 확대하는
                    결정을 내릴 수 있습니다.
                  </StyledLi>
                  <StyledLi>
                    <FontBold>고객 세분화 및 타겟 마케팅:</FontBold> 이용권
                    종류는 고객을 자연스럽게 세분화하는 기준이 됩니다. 일반
                    회원권을 이용하는 고객층과 고가의 PT 회원권을 구매하는
                    고객층은 필요(Needs)와 특성이 다릅니다. 각 그룹의 특성을
                    파악하면, 일반 회원에게는 PT 체험 세션을 제안하는 상향
                    판매(Up-selling)를, 필라테스 회원에게는 요가 클래스를
                    추천하는 교차 판매(Cross-selling) 등 맞춤형 마케팅 전략을
                    구사할 수 있습니다.
                  </StyledLi>
                  <StyledLi>
                    <FontBold>운영 자원의 효율적 배분:</FontBold> 이용권별 회원
                    수는 인력과 공간을 어떻게 배분해야 할지에 대한 명확한
                    데이터를 제공합니다. PT 회원 수가 많다면 더 많은 트레이너를
                    채용하거나 교육에 투자해야 합니다. 특정 그룹 클래스(GX)
                    이용권 판매가 저조하다면 해당 클래스의 시간대를 변경하거나
                    다른 프로그램으로 대체하는 것을 고려해야 합니다. 이는 '감'이
                    아닌 데이터에 기반한 운영 효율화의 시작입니다.
                  </StyledLi>
                  <StyledLi>
                    <FontBold>회원 이탈 원인 분석:</FontBold> 만약 특정
                    이용권(예: 초급자용 3개월권)을 구매한 회원들의 이탈률이 유독
                    높다는 사실을 발견했다면, 해당 그룹을 위한 온보딩
                    프로그램이나 참여 유도 전략에 문제가 있다는 것을 파악하고
                    개선 조치를 취할 수 있습니다.
                  </StyledLi>
                </StyledUl>
              </StyledLi>
            </Ol>
            <p>
              결론적으로, <FontBold>총 유효회원수</FontBold>는 우리 헬스장의
              전체적인 규모와 성장 속도를 알려주는 '속도계'와 같습니다. 반면,{" "}
              <FontBold>이용권 종류별 유효회원수</FontBold>는 엔진의 각 부분이
              어떻게 작동하고 있는지, 어디에 연료를 더 공급하고 어떤 부품을
              수리해야 할지를 알려주는 '정밀 계기판'입니다. 이 두 가지 지표를
              매월 함께 추적하고 분석할 때, 비로소 데이터에 기반하여 비즈니스를
              지속 가능하게 성장시키는 전략적인 의사결정을 내릴 수 있습니다.
            </p>
            <Card>
              <FontBold>[향후 업데이트 예정]</FontBold>
              <StyledUl style={{ paddingTop: 4, paddingBottom: 0 }}>
                <StyledLi>
                  회원의 이탈율과 유지율, 각 이용권 별 이탈율과 유지율
                </StyledLi>
                <StyledLi>우리 센터 회원의 LTV(총 생애가치)</StyledLi>
                <StyledLi>상품별 유효회원 수와 유지율 분석</StyledLi>
              </StyledUl>
            </Card>
          </SpaceY>
        ),
      },
    ],
  },
} as const;

export type HelpType = keyof typeof HELP_CONTENT;
